<button mat-icon-button class="view-remito-buttons" *ngIf="isPrint" (click)="printRemitos()"
        [disabled]="_disabled || isLoading">
  <mat-icon *ngIf="!isLoading">print</mat-icon>
  <mat-spinner *ngIf="isLoading" class="loading-spinner-small" diameter="15"></mat-spinner>
</button>
<button mat-icon-button class="view-remito-buttons" *ngIf="!isPrint" (click)="emailRemitos()"
        [disabled]="_disabled || isLoading">
  <mat-icon *ngIf="!isLoading">email</mat-icon>
  <mat-spinner *ngIf="isLoading" class="loading-spinner-small" diameter="15"></mat-spinner>
</button>
